import { useLang } from '@/app/utils/useLang';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

interface EventStatusProps {}

const EventStatus: React.FC<EventStatusProps> = (props) => {
    const { t } = useLang('EventStatus');
    const { locale = 'us' } = useRouter();

    return (
        <div className={`${styles.EventStatus} GtmModuleData-section sr-layout`} data-section-id="service-renewal-event-status" id="event-status">
            <div className="">
                <div className="status-badge">{t('title')}</div>
                <div className="status-body">
                    <p className="status-desc">{t('desc')}</p>
                </div>
            </div>
        </div>
    );
};

export default EventStatus;
